import { theming } from "@staccx/bento"
import "./properties"
import "./variants"

export const theme = theming.theme
